const marketplacePaths = {
  CLOUDBEDS: '/cloudbeds',
};

export type MarketplacePaths = typeof marketplacePaths;

export default {
  marketplacePaths: marketplacePaths as MarketplacePaths,
};
